export const AuthorModel = {
  bio: "",
  meta: [],
}
